module.exports = __webpack_public_path__ + "img/advice-9.fe7ea1f0.png";